import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ButtonOverride from "../../../../../components/buttonoverride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply, faPenToSquare, faSave } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { NumericFormat } from "react-number-format";

const StandardView = ({ toggleEditMode, item, remove, types, readOnly = false }) => {
    const type = types.find(t => t.id === item.type);

    //console.log(item);
    const total = item.amount.toFixed(2);

    const _toggleEditMode = () => {

        toggleEditMode();
    }

    return (
        <>
            <tr>
                <td className="align-middle">
                    {type.name}
                </td>
                <td className="align-middle">{item.detail}</td>
                <td className="align-middle">{total}</td>
                {
                    !readOnly
                    ?
                        <td className="align-middle ">
                            <div className="d-flex justify-content-around">
                                <div>
                                    <Button size="sm" type="button" variant="primary" className="me-1" title="Edit Row" aria-label="Edit Row" onClick={_toggleEditMode}>
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                    </Button>
                                </div>
                                <div>
                                    <Button size='sm' type="button" variant="danger" title="Remove Item" aria-label="Remove Item" onClick={() => remove(item.id)}>
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </Button>
                                </div>
                            </div>
                        </td>
                    :
                        null
                }
            </tr>
            
        </>
    )
}

const EditView = ({ toggleStandardMode, update, item, types }) => {
    const { control, register, handleSubmit, setValue, watch } = useForm({ defaultValues: { type: -1, detail: '', amount: 0.00 } });

    const _onSubmit = (data) => {
        update(data);
        toggleStandardMode();
    }

    useEffect(() => {
        setValue('detail', item.detail);
        setValue('amount', item.amount);
        setValue('type', item.type);
    }, [])

    const currencyValue = watch('amount', '');
    return (
        <tr>
            <td className="align-middle">
                <select {...register('type', { valueAsNumber: true })}>
                    {
                        types.map((item) => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                        ))
                    }
                </select>
            </td>
            <td className="align-middle">
                <input type="text" placeholder="Detail" {...register('detail')} />
            </td>
            <td className="align-middle">
                <Controller
                    name="amount"
                    control={control}
                    rules={{
                        validate: (values) => {
                            if (values !== undefined && values !== null) {
                                if (values < 0.01)
                                    return "*Amount is required."
                                return true;
                            }
                            else {
                                return "*Amount is required."
                            }
                        }
                    }}
                    render={({ field }) => (
                        <NumericFormat value={field.value} id="amountquickadd" placeholder="Amount" style={{ width: '100%', height: '32px' }} prefix={'$'} decimalScale={2} fixedDecimalScale={true} allowNegative={false} onValueChange={(values) =>  field.onChange(values.floatValue)} />
                    )}
                />
            </td>
            <td className="align-middle">
                <div className="d-flex align-items-center">
                    <ButtonOverride type="submit" className='me-2 p-0' title="Save Changes" aria-label="Save Changes" onClick={handleSubmit(_onSubmit)}>
                        <FontAwesomeIcon icon={faSave} size="lg" style={{ color: '#0d6efd' }} />
                    </ButtonOverride>
                    <ButtonOverride type="button" className='ms-2 p-0' title="Cancel Changes" aria-label="Cancel Changes" onClick={toggleStandardMode}>
                        <FontAwesomeIcon icon={faMultiply} size="lg" />
                    </ButtonOverride>
                </div>
            </td>
        </tr>
    )
}

const ReceiptPanelItem = ({ item, types = [], remove, update,addflag,removeFlag,updateFlag,addResolution, readOnly = false }) => {
    const [editMode, setEditMode] = useState(false);

    const _toggleMode = () => {
        setEditMode(!editMode);
    }

    return (
        <>
            {
                editMode && !readOnly
                    ?
                    <EditView toggleStandardMode={_toggleMode} update={update} item={item} types={types} />
                    :
                    <StandardView toggleEditMode={_toggleMode} remove={remove} item={item} types={types} readOnly={readOnly}
                        addflag={addflag} updateFlag={updateFlag} removeFlag={removeFlag}
                        addResolution={addResolution}
                    />
            }
        </>
    )
}

export default ReceiptPanelItem;
